import React, { useEffect, useState, useCallback } from 'react';
import Dialog from '@material-ui/core/Dialog';
import Close from '@material-ui/icons/Close';
import Button from 'components/CustomButtons/Button.jsx';
import DialogTitle from '@material-ui/core/DialogTitle';
import CustomInput from 'components/CustomInput/CustomInputValidate.jsx';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Person from '@material-ui/icons/Person';
import Star from '@material-ui/icons/Star';
import { ClipLoader } from 'react-spinners';
import PropTypes from 'prop-types';
import ContactsNewProperty from "containers/CRM/Contacts/ContactsNewProperty";
import { connect } from 'react-redux';
import { clone } from 'shared/utility';
import * as actions from 'store/actions';
import _, { get } from 'lodash';
import { getUser } from '../../shared/authValidation';
import { IconButton, Tab, Tabs } from '@material-ui/core';
import CustomSelect from '../CustomSelect/CustomSelect';
import crmObj from 'containers/CRM/crmObj';
import Notification from '../Notification/Notification';
import { formatDate, handleError } from '../../shared/utility';
import CommissionSplitsForm from '../../containers/CommissionSplits/CommissionSplitsForm';
import axios from 'store/axios/axios-crm';
import ContactsProperty from '../../containers/CRM/Contacts/ContactsProperty';
import { getIlliNumber } from '../../containers/RSheets/RSheetsLogic';
import { property_is_dict } from '../../containers/CRM/Properties/PropertiesLogic';
import CustomNativeSelect from '../CustomSelect/CustomNativeSelect';
import axios_cs from 'store/axios/axios-commission-splits';

function extractNumber(str) {
  const match = str.match(/^(BR|TR|NL|9|C)(\d{3,})$/i);
  return match ? match[2] : null;
}


const CustomDialogWithProperty = (props) => {
    const [openedChooseType, setOpenedChooseType] = useState(null);
    const [openedNewProperty, setOpenedNewProperty] = useState(false);
    const [currentTab, setCurrentTab] = useState('illi');
    const [userType, setUserType] = useState('E');
    const [theType, setTheType] = useState('');
    const [choice, setChoice] = useState('');
    const [options, setOptions] = useState([]);
    const [subType, setSubtype] = useState('');
    const [acronymType, setAcronymtype] = useState('');
    const [notification, setNotification] = useState(false);
    const [checkProperty, setCheckProperty] = useState(null);
    const [chooseCS, setChooseCS] = useState(null);
    const [viewCS, setViewCS] = useState(null);
    const [propertyData, setPropertyData] = useState(null);
    const [cs_approved_properties, set_cs_approved_properties] = useState(null);

    const { indx, desc, open, close, title, options: opts, label, current,
        illi_properties, own_properties, own_shared_properties, is_lease, has_spaces,
        is_sale,
        filtered_spaces,
        filter_message,
        rs_type
    } = props;

    const getCS = async (property_id) => {
        try {
            const css = await axios_cs.get('/entries?property_id='+property_id);
            console.log('css', css.data, property_id);
            return css.data;
        } catch(e) {
            handleError(e);
        }
        return [];
    }

    useEffect(() => {
        const userPerms = getUser();
        if (userPerms) {
            setUserType(userPerms.type);
            if (userPerms.type === 'A') {
                setCurrentTab('Agent');
            }
        }
        if (props.prefill_property_name) {
            setChoice(props.prefill_property_name);
        }
        console.log('userPerms', userPerms)
        const arr = Object.keys(userPerms.permObj);
        const has_full_property_access = arr.indexOf('CRM agent_access_illi_db_full') !== -1 ? true : false;
        if (props.propertyOwner === 'illi' && userPerms.type === 'A' && has_full_property_access) {
            setCurrentTab('illi');
        }
    }, []);

    useEffect(() => {
        console.log('cjeck -', props.checking_property, checkProperty)
        if (props.checking_property && checkProperty) {
            console.log('checking property', props.checking_property);
            if (props.checking_property) {
                if (props.checking_property.length > 0) {
                    setNotification('Property chosen is a duplicate');
                } else {
                    props.choose(checkProperty);
                }
            }
            setCheckProperty(null);
        }
    }, [props.checking_property, checkProperty]);

    const searchAPI = (the_choice) => {
        const is_illi_number = extractNumber(the_choice);
        if (is_illi_number) {
            the_choice = is_illi_number;
        }
        if (props.propertyOwner) {
            const params = {
                names_only: 'all',
                search_term: the_choice,
                property_owner: props.propertyOwner,
                check_for_duplicates: props.check_for_duplicates
            };
            if (props.rs_type) {
                params.check_for_cs = 1;
            }
            if (props.full_property_access_only) {
                params.full_property_access_only = true
            }
            props.getProperties(params)
        } else {
            const params = {
                names_only: 'all',
                search_term: the_choice,
                check_for_duplicates: props.check_for_duplicates
            };
            if (props.rs_type) {
                params.check_for_cs = 1;
            }
            if (props.full_property_access_only) {
                params.full_property_access_only = true
            }
            props.getProperties(params);
        }
    }

    const searchIt = useCallback(_.debounce(searchAPI, 600), []);

    useEffect(() => {
        if (choice) {
            if (choice.length > 1) {
                searchIt(choice);
            }
        }
    }, [choice]);

    useEffect(() => {
        if (illi_properties && own_properties && own_shared_properties) {
            renderOptions();
        }
    }, [illi_properties, own_properties, own_shared_properties]);

    useEffect(() => {
        renderOptions();
    }, [currentTab]);

    let hide_illi_tab = false;
	if (props.loggedInUser) {
		// shown if in CRM association editing mode (e.g. company properties, contact properties)
		if (props.loggedInUser.type === 'A') {
            const usr = getUser();
            
			const perms = usr.permObj;
			hide_illi_tab = true;
			// check if user has permissions
			if (perms.hasOwnProperty('CRM agent_access_illi_db') || 
				perms.hasOwnProperty('CRM agent_access_illi_db_full')) {
					hide_illi_tab = false;
                    console.log('checking...', usr);
			}
		}
	}

    const loadProperty = async (property_id) => {
        setPropertyData(null);
        try {
            let url = "/property?id=" + property_id;
            const response = await axios.get(url);
            console.log('loaded property', response.data);
            setPropertyData(response.data);
        } catch (err) {
            handleError(err);
            alert('Could not load property');
        }
    }

	const filterProperties = (properties, {
		property_is_for=[],
		has_spaces = false,
		filtered_spaces = [],
		exclude_use_types = ["Residential", "Multi-Family"],
        property_is_for_only = false
	  }) => {
        console.log('da properties', properties)
		return properties.map(p => {
            p.illi_number_final = getIlliNumber(p);
            return p;
        }).filter(property => {
			let includeProperty = true;
            const illi_number = property.illi_number_final;
            const property_is_value = property.property_is ? property_is_dict[property.property_is] : '';

            // filter by illi number prefix
            console.log('property is forr 1', `( ${choice} )`, property_is_value, property.property_is);
            if (choice === 'tr' || 
                choice === 'TR' ||
                choice === 'br' || 
                choice === 'BR' ||
                choice === 'nl' ||
                choice === 'NL' || 
                choice === 'c' || 
                choice === 'C' ||
                choice === 'R' ||
                choice === 'r' ||
                choice == '9') {
                includeProperty = false;
                console.log('property is forr -1 checked out', property_is_value);
                if (property_is_value) {
                    console.log('property is forr 0 checked out', `(${property_is_value.toLowerCase()})`, choice.toLowerCase());
                    if (property_is_value.toLowerCase() === choice.toLowerCase()) {
                        console.log('property is forr 1 checked out');
                        includeProperty = true;
                    }
                }
            }

            if (rs_type === 'Lease' || rs_type === 'Sub-Lease' || rs_type === 'Tenant Rep') {
                // Any property for lease as long as there is at least one space that isn't multi-family or residential 
                // since those can't be used here.
                if (!property.property_is_for) { 
                    includeProperty = false;
                } else {
                    if (property.property_is_for.indexOf('Lease') === -1) {
                        includeProperty = false;
                    } else {
                        let passing_space = [];
                        const spaces = property.spaces || [];
                        if (spaces.length === 0) {
                            includeProperty = false;
                        } else {
                            spaces.forEach(sp => {
                                if (sp.use_type !== 'Multi-Family' && sp.use_type !== 'Residential') {
                                    passing_space.push(sp.use_type);
                                }
                            })
                            if (passing_space.length === 0) includeProperty = false;
                        }
                        if (property.lease_space_type === 'Lease with Single Space') {
                            if (property.single_space_total_sqft && 
                                (property.single_space_use_type !== 'Multi-Family' && property.single_space_use_type !== 'Residential')) {
                                includeProperty = true;
                            }
                        }
                    }
                }
                
            } else if (rs_type === 'Residential') {
                // Lease only, Multi-Family & Residential Spaces only.
                if (!property.property_is_for) { 
                    includeProperty = false;
                } else {
                    // Lease only
                    if (property.property_is_for.indexOf('Lease') === -1) {
                        includeProperty = false;
                    } else {
                        let passing_space = [];
                        const spaces = property.spaces || [];
                        if (spaces.length === 0) {
                            includeProperty = false;
                        } else {
                            // Multi-Family & Residential Spaces only.
                            spaces.forEach(sp => {
                                if (sp.use_type === 'Multi-Family' || sp.use_type === 'Residential') {
                                    passing_space.push(sp.use_type);
                                }
                            })
                            if (passing_space.length === 0) includeProperty = false;
                        }
                        if (property.lease_space_type === 'Lease with Single Space') {
                            if (property.single_space_total_sqft && 
                                (property.single_space_use_type === 'Multi-Family' || property.single_space_use_type === 'Residential')) {
                                includeProperty = true;
                            }
                        }
                    }
                }
            } else if (rs_type === 'No Listing') { 
                if (property.property_is !== 'No Listing') includeProperty = false;
            } else {
                console.log('property is forr', property_is_for);
                if (property_is_for.length > 0) {
                    const propertyIsFor = property.property_is_for ? property.property_is_for.split(',') : [];
      
                    if (property_is_for_only && property_is_for.length > 0) {
                        
                        includeProperty = propertyIsFor.length > 0 && propertyIsFor.every(r => property_is_for.includes(r));
                        console.log('included 1', includeProperty);
                    } else {
                        const norm = s => s.toLowerCase().replace(/^for\s+/, '').trim();
                        const setB = new Set(property_is_for.map(norm));
                        includeProperty = propertyIsFor.some(x => setB.has(norm(x)));

                        //includeProperty = propertyIsFor.some(r => property_is_for.includes(r));
                      console.log('included 2', includeProperty, propertyIsFor, property_is_for);
                    }
      
                    if (includeProperty && has_spaces) {
                      const spaces = property.spaces || [];
                      const filteredSpaces = filtered_spaces.length > 0 ? 
                          spaces.filter(space => filtered_spaces.includes(space.use_type)) : spaces;
                      const includedSpaces = exclude_use_types.length > 0 ? 
                          filteredSpaces.filter(space => !exclude_use_types.includes(space.use_type)) : filteredSpaces;
                      includeProperty = includedSpaces.length > 0
                      if (property.lease_space_type === 'Lease with Single Space') {
                            if (property.single_space_total_sqft) {
                                includeProperty = true;
                            }
                      }
                    }
                }
            }

            // only TR illi numbers can be used in Tenant Rep RS
            // REMOVED 1/27/2026 per Danny Slack
            console.log('checking rs type', rs_type);
            if (rs_type) {
                if ((rs_type !== 'Tenant Rep' && rs_type !== 'Residential') && illi_number) {
                    if (rs_type !== 'Option Commission') {
                        if (illi_number.indexOf('TR') !== -1) {
                            includeProperty = false;
                        }
                    }
                }
            }

			return includeProperty;
		  });
	  };

	const renderOptions = () => {
        let opts;
        if (currentTab === 'illi') {
            opts = filterProperties(clone(illi_properties), { 
                has_spaces, filtered_spaces,
                property_is_for: props.property_is_for ? props.property_is_for : [], // filter for e.g. Lease, Sale 
                exclude_use_types: props.exclude_use_types,
                property_is_for_only: props.property_is_for_only
            });
        } else {
            const illi_keys = new Set();
            (illi_properties || []).forEach(p => {
                if (p && p.illi_number) illi_keys.add(String(p.illi_number));
            });
            const own_and_shared_properties = own_properties.concat(own_shared_properties)
                .filter(p => !(p && p.illi_number && illi_keys.has(String(p.illi_number))));
            opts = filterProperties(clone(own_and_shared_properties), {
                has_spaces, filtered_spaces,
                property_is_for: props.property_is_for ? props.property_is_for : [],
                exclude_use_types: props.exclude_use_types,
                property_is_for_only: props.property_is_for_only
            });
            if (props.full_property_access_only) {
                opts = opts.filter(o => {
                    if (o.hasOwnProperty('access')) {
                        if (o.access === 'F') {
                            return true;
                        }
                    } else {
                        return true;
                    }
                })
            }
        }
        setOptions(opts);
    }

    const ct = currentTab === 'illi' ? 0 : 1;

    const oo = options.filter((o, i) => {
        if (currentTab === 'Agent' && o.user_id === 1) {
            return false;
        }
        if (currentTab === 'illi' && o.user_id !== 1) {
            return false;
        }
        return true;
    });

    const user = getUser();
    const userPerms = Object.keys(user.permObj);
    const has_read_property_access = userPerms.indexOf('CRM agent_access_illi_db') !== -1 ? true : false;
    const has_full_property_access = userPerms.indexOf('CRM agent_access_illi_db_full') !== -1 ? true : false;
    console.log('CustomDialogWithProperty 1', props, options);

    return (
        <div>
            <Dialog open={props.open} keepMounted onClose={props.close} maxWidth='sm' fullWidth={true}>
                <DialogTitle>
                    <div className="close-btn" onClick={() => { props.close() }}><Close /></div>
                    <div style={{ textAlign: 'center' }}>{props.title}</div>
                    {!props.no_new_property && <Button className="outlined-btn"
                        size="sm"
                        onClick={() => {
                            setOpenedNewProperty(true);
                        }}
                    ><i className="fa fa-plus"></i> CREATE NEW {props.propertyType} PROPERTY</Button>}
                </DialogTitle>

                {<div style={{ margin: '0 20px' }}>
                    {userType !== 'E' && <Tabs
                        TabIndicatorProps={{ style: { background: '#da3b2f', borderBottom: '1px solid #da3b2f', color: '#da3b2f' } }}
                        style={{ marginBottom: 10 }}
                        value={currentTab === 'illi' ? 0 : 1}>
                        {(has_read_property_access || has_full_property_access) && <Tab
                            onClick={() => {
                                setCurrentTab('illi');
                            }}
                            style={{ 
                                color: ct === 0 ? '#da3b2f' : 'rgba(0, 0, 0, 0.87)',
                                display: hide_illi_tab ? 'none' : 'block'
                            }}
                            tabIndex={0}
                            label='illi Properties'
                            icon={<i className="fas fa-building"></i>}
                        />}
                        {<Tab
                            onClick={() => {
                                setCurrentTab('Agent');
                            }}
                            style={{ color: ct === 1 ? '#da3b2f' : 'rgba(0, 0, 0, 0.87)' }}
                            tabIndex={1}
                            label='Your Properties'
                            icon={<i className="fas fa-user"></i>}
                        />}
                    </Tabs>}
                </div>}

                <div style={{ textAlign: 'center', padding: 20 }}>
                    {filter_message && <div className="red-text">
                            <div>FILTERS:</div>
                            {filter_message}
                    </div>}
                    {/* {(is_lease || has_spaces) && <div className="red-text">
                        FILTERS:<br />
                        {is_lease && <span className="red-text">Lease property only</span>}
                        {(is_lease && has_spaces) && <span>,</span>}
                        {has_spaces && <span className="red-text">Property with spaces only</span>}
                        {notification && <div className="red-text mt-20">,{notification}</div>}
                    </div>} */}
                    <CustomInput
                        label={'Search by Street Name , Project Name or illi Number'}
                        value={choice}
                        onChange={(e) => {
                            setNotification('');
                            setChoice(e.target.value);
                        }}
                        autoFocus={true}
                    />

                    {props.loading && <div>
                        <div style={{ margin: '0 auto', display: 'inline-block' }}><ClipLoader /></div>
                    </div>}
                    {!props.loading && <div>
                        {options && <div style={{ height: !choice ? 100 : 300, overflowY: 'scroll', padding: 10, backgroundColor: '#f1f1f1' }}>
                            {!choice && <div style={{ marginTop: 20 }}><em>Enter letters or numbers from the property's street or project name<br />you are searching for in the line above</em></div>}
                            {(choice && options) && <div>
                                {options.length === 0 && <div><em>0 Results</em></div>}
                            </div>}
                            {(!props.loading && choice) && <div>
                                {options.length > 0 && <div><em>{options.length.toLocaleString()} Result(s)</em></div>}
                            </div>}
                            {(options.length !== 0 && choice) && <List component="nav">
                                {options.map((o, i) => {
                                    let restricted = true;
                                    if (props.rs_type) {
                                        // RS property search
                                        if (user) {
                                            console.log('checking restricted 1', user.permObj, user)
                                            if (user.permObj) {
                                                if (user.permObj.hasOwnProperty('Routing rs_admin')) {
                                                    restricted = false;
                                                }
                                            }
                                        }
                                        if (restricted) {
                                            console.log('checking restricted 2', props)
                                            // check if current user has an approved CS 
                                            if (props.cs_approved_properties) {
                                                for (let i = 0; i < props.cs_approved_properties.length; i++) {
                                                    const cap = props.cs_approved_properties[i];
                                                    if (cap.property_id === o.id) {
                                                        restricted = false;
                                                    }
                                                    if (user.type === 'A') {
                                                        // check user.id 
                                                        console.log('capp', cap);
                                                    }
                                                }
                                            }
                                            
                                        }
                                    } else {
                                        // used everywhere else;
                                        restricted = false;
                                    }
                                    const range1 = o.street_range1 && (o.street_range2 && o.address_is_range === 'Yes') ? `${o.street_range1}-${o.street_range2}` : '';
                                    const range2 = o.street2_range1 && (o.street2_range2 && o.address2_is_range === 'Yes') ? `${o.street2_range1}-${o.street2_range2}` : '';
                                    const street1 = `${range1} ${o.street1 ? o.street1 : ''}`;
                                    const street2 = `${range2} ${o.street2 ? o.street2 : ''}`;
                                    const added = (street1 && o.city) ? `${street1} ${street2}, ${o.city}` : '';
                                    const restricted_span = <div style={{color:'red',fontSize:9}}>Commission Splits Form for Your User and This Property Not Found</div>;
                                    const illi_num = o.illi_number_final ? `illi #${o.illi_number_final} - ` : ``;
                                    const desc = props.desc ?
                                        <div style={{opacity: restricted ? 0.6 : 1}}><div>{illi_num} <strong>{o[props.desc]}</strong></div>
                                            {restricted ? restricted_span : null}
                                        <span>{added}</span></div>
                                        :
                                        <div style={{opacity: restricted ? 0.6 : 1}}><div>{illi_num} <strong>{o.name}</strong></div>
                                            {restricted ? restricted_span : null}
                                        <span>{added}</span></div>;
                                    return (
                                        <ListItem
                                            button
                                            key={`propertyoptions-${i}`}
                                            onClick={async () => {
                                                if (restricted) return;
                                                let missing = [];
                                                if (props.required_fields) {
                                                    if (props.required_fields.length > 0) {
                                                        props.required_fields.forEach(pr => {
                                                            if (!o[pr]) {
                                                                missing.push(pr.split('_').join(' ').toUpperCase());
                                                            }
                                                        })
                                                    }
                                                }
                                                if (missing.length > 0) {
                                                    return setNotification(`Missing Required fields ${missing}`);
                                                }
                                                if (props.askForType) {
                                                    setOpenedChooseType(o);
                                                } else {
                                                    console.log('cjeck', props.check_for_duplicates);
                                                    if (props.check_for_duplicates) {
                                                        if (props.check_for_duplicates === 'commission_splits') {
                                                            setCheckProperty(o);
                                                            props.getCommissionSplitsPropertyExistence(o.id);
                                                        }
                                                    } else {
                                                        let cs = null;
                                                        let cs_arr = [];
                                                        if (props.cs_approved_properties) {
                                                            props.cs_approved_properties.forEach(csa => {
                                                                if (o.id === csa.property_id) {
                                                                    cs_arr.push(csa);
                                                                    cs = csa;
                                                                }
                                                            })
                                                        }
                                                        console.log('choksong', props.choose_cs, restricted, props.cs_approved_properties)
                                                        if (props.choose_cs && restricted) {
                                                            setChooseCS(o)
                                                        } else if (props.choose_cs && !restricted && cs_arr.length > 1) {
                                                            setChooseCS(o)
                                                        } else {
                                                            props.choose(o, null, cs);
                                                        }
                                                    }
                                                }
                                            }}
                                        >
                                            {props.icon === 'person' && <ListItemIcon>
                                                <Person />
                                            </ListItemIcon>}
                                            {(props.icon !== 'person' && props.icon) && <ListItemIcon>
                                                {props.icon}
                                            </ListItemIcon>}
                                            <ListItemText inset primary={desc} />
                                            {/* <ListItemSecondaryAction>
                                                {current === desc && <Star />}
                                            </ListItemSecondaryAction> */}
                                            <ListItemSecondaryAction>
                                                <IconButton onClick={() => {
                                                        loadProperty(o.id);
                                                    }}>
                                                    <i className="fa fa-eye"></i>
                                                </IconButton>
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    );
                                })}
                            </List>}
                        </div>}
                    </div>}

                    {openedNewProperty && <ContactsNewProperty
                        open={openedNewProperty}
                        close={() => {
                            setOpenedNewProperty(false);
                            if (props.askForType) {
                                return;
                            }
                            if (props.do_not_close_on_choose) return;
                            props.close();
                        }}
                        propertyType={props.propertyType}
                        create_and_choose={(chosen) => {
                            if (props.askForType) {
                                return setOpenedChooseType(chosen);
                            }
                            console.log('chosen new property', chosen);
                            if (props.choose_cs) {
                                setChooseCS(chosen);
                            } else {
                                props.create_and_choose(chosen);
                            }
                        }}
                        theContactData={props.theContactData}
                        is_lease={true}
                        property_is_for_override={props.property_is_for_override}
                        success_data={props.success_data}
                    />}

                    <Button
                        color='white'
                        style={{ marginRight: 10, marginTop: 20 }}
                        onClick={() => {
                            props.close();
                        }}
                    >
                        CLOSE
                    </Button>
                </div>

                {openedChooseType && <Dialog
                    open={true} keepMounted onClose={() => { setOpenedChooseType(null); }} 
                    maxWidth='sm' fullWidth={true}
                >
                    <DialogTitle>
                        <div className="close-btn" onClick={() => { setOpenedChooseType(null); }}><Close /></div>
                        <div style={{ textAlign: 'center' }}>
                            Choose Contact Type for this Property<br />
                            {openedChooseType && <div style={{opacity:0.5}}>{openedChooseType.name}</div>}
                        </div>
                    </DialogTitle>
                    <div className="dialog-body" style={{ margin: '0 20px', minHeight:400 }}>
                        <CustomSelect 
                            default={theType}
                            choose={(typeChosen) => {
                                setTheType(typeChosen);
                                if (typeChosen === 'Other') {
                                    setSubtype('');
                                } else {
                                    setSubtype(crmObj.contactOrCompanyPropertySubTypes[typeChosen].subtype);
                                }
                                setAcronymtype(crmObj.contactOrCompanyPropertySubTypes[typeChosen].type);
                            }}
                            options={crmObj.contactOrCompanyPropertyTypes}
                            label="Choose one"
                        />
                        {theType === 'Other' && <CustomInput
                            label="Enter Other type"
                            value={subType}
                            onChange={(e) => {
                                setSubtype(e.target.value);
                            }}
                        />}
                        {theType && <Button color="white"
                            onClick={() => {
                                if (theType === 'Other') {
                                    if (!subType) {
                                        return setNotification('Please enter an "Other" type.');
                                    }
                                }
                                const typeObj = {
                                    theType, 
                                    acronymType, 
                                    subType
                                };
                                console.log('typeObj', typeObj);
                                props.choose(openedChooseType, typeObj)
                                props.close();
                            }}
                        >SUBMIT</Button>}
                    </div>
                </Dialog>}

                {notification && <Notification 
                    message={notification}
                    open={notification ? true : false}
                    close={() => { 
                        props.setCommissionSplitsPropertyExistence();
                        setNotification('') 
                    }}
                />}

                {chooseCS && <Dialog
                    open={true} keepMounted onClose={() => { setChooseCS(null); }} 
                    maxWidth='sm' fullWidth={true}
                >
                    <DialogTitle>
                        <div className="close-btn" onClick={() => { setChooseCS(null); }}><Close /></div>
                        <div style={{ textAlign: 'center' }}>
                            Choose Commission Split for this Property
                        </div>
                    </DialogTitle>
                    <div className="dialog-body" style={{ margin: '0 20px', minHeight:400 }}>
                        {props.cs_approved_properties.map((cap,x) => {
                            if (cap.property_id === chooseCS.id) {
                                console.log('nocap', cap, chooseCS);
                                const jdata = cap.json_data;
                                return <div key={`xxs-${x}`} style={{marginBottom:20}} className="boxed">
                                    Date Executed: {formatDate(cap.date_modified)}<br />
                                    Associates: {jdata.contacts.map(jdc => {
                                        const first_name = jdc.first_name ? jdc.first_name : '';
                                        const last_name = jdc.last_name ? jdc.last_name : '';
                                        return `${first_name} ${last_name}`;
                                    }).join(',')}<br />
                                    {jdata.notes_now && <div className="boxed">
                                        Notes: {jdata.notes_now}
                                    </div>}
                                    <Button color="rose" onClick={() => {
                                        console.log('chosun galbi', chooseCS, cap);
                                        props.choose(chooseCS, null, cap);
                                        setChooseCS(null);
                                    }}>CHOOSE CS</Button>

                                    <Button color="white" onClick={() => {
                                        setViewCS(cap);
                                    }}>VIEW CS</Button>
                                </div>
                            } else {
                                return null;
                            }
                        })}

                        {viewCS && <Dialog
                            open={true} keepMounted onClose={() => { setViewCS(null); }} 
                            maxWidth='lg' fullWidth={true}
                        >
                            <DialogTitle>
                                <div className="close-btn" onClick={() => { setViewCS(null); }}><Close /></div>
                                <div style={{ textAlign: 'center' }}>
                                    Commission Split for this Property
                                </div>
                            </DialogTitle>
                            <div>
                                <CommissionSplitsForm 
                                    tab="full"
                                    formData={viewCS.json_data}
                                    entryData={viewCS}
                                    action="view"
                                    close={() => {
                                        setViewCS(null);
                                    }}
                                    formAction="view"
                                    notification={null}
                                    setNotification={(notification) => {
                                        
                                    }}
                                    viewOnly={true}
                                />
                            </div>
                        </Dialog>}

                    </div>

                </Dialog>}

                {propertyData && 
                    <ContactsProperty 
                        open={true}
                        close={() => {
                            setPropertyData(null);
                        }}
                        thePropertyData={propertyData}
                        theContactData={null}
                    />}
            </Dialog>
        </div>
    );
};

CustomDialogWithProperty.propTypes = {
    title: PropTypes.string.isRequired,
    label: PropTypes.string,
    close: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    choose: PropTypes.func.isRequired,
    indx: PropTypes.string,
    desc: PropTypes.string,
    current: PropTypes.string,
    icon: PropTypes.object
};

const mapStateToProps = state => {
    const p = state.crm_properties;
    return {
        loading: p.loading,
        illi_properties: p.illi_properties,
        own_properties: p.own_properties,
        own_shared_properties: p.own_shared_properties,
        success_data: p.success_data,
        checking_property: state.commission_splits.checking_property,
        cs_approved_properties: p.cs_approved_properties
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getProperties: (params) => {
            dispatch(actions.getProperties(params));
        },
        getCommissionSplitsPropertyExistence: (data) => {
            dispatch(actions.getCommissionSplitsPropertyExistence(data));
        },
        setCommissionSplitsPropertyExistence: () => {
            dispatch(actions.getCommissionSplitsPropertyExistence());
        },
        setCommissionSplitsPropertyExistence: () => {
            dispatch(actions.setCommissionSplitsPropertyExistence());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomDialogWithProperty);
